// extracted by mini-css-extract-plugin
export default {"PfsAscend":"PFSAscend_PfsAscend__yeyE1","content":"PFSAscend_content__8KB6s","homeBtn":"PFSAscend_homeBtn__OIiXC","logo":"PFSAscend_logo__kT6dS"};